/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
// import HubspotForm from 'react-hubspot-form';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Image from 'components/Image';
import Modal from 'components/Modal';
import FloatingText from 'components/FloatingText';
import SectionIndustries from 'components/SectionIndustries';
import SectionStats from 'components/SectionStats';
import SectionHomeHero from 'components/SectionHomeHero';
import SectionHomeClients from 'components/SectionHomeClients';

import FreshFlows from 'images/home/fresh-flows.svg';
import ConversationsSkills from 'images/home/conversations-and-skills.svg';
import InsightsAnalytics from 'images/home/insight.svg';
import ProfileIcon from 'images/home/profile-icon.svg';

import { indexSolutions } from 'utils/contentProvider';

import { IndexContainer } from 'styles/home';

// import {setUTMToHubspotForm} from '../utils/utmUtil'

const IndexPage = ({ path }) => {
  const [currentSolution, setCurrentSolution] = useState(0);
  const [isVideoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://american-technology40184.activehosted.com/f/embed.php?id=1';
    script.type = 'text/javascript';
    script.charset = 'utf-8';

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  function solutionChangeHandler(e) {
    setCurrentSolution(Number(e.target.dataset.id));
  }

  function toggleVideoOpen() {
    setVideoOpen(!isVideoOpen);
  }
  

  return (
    <>
      <Meta
        title="Modern Enterprise Solutions - Software Development, Product Development, Solution Development For Business"
        description="ATC scales enterprise businesses by building solutions for real customer problems, from ideation, development, through to support and evolution."
      />
      <Layout
        background="#11111C"
        path={path}
        renderOutsideScrollContainer={
          <Modal isOpen={isVideoOpen} toggle={toggleVideoOpen}>
            <iframe
              src="https://www.youtube.com/embed/r9O6v0M4Lc0"
              width="100%"
              height="100%"
              frameBorder="0"
              title="ATC mission"
              webkitallowfullscreen
              mozallowfullscreen
              allowFullScreen
            ></iframe>
          </Modal>
        }
      >
        <IndexContainer>
          <SectionHomeHero />

          <section>
            <div className="tabs-area-main">
              <div className="container">
                <div className="single-tab-area">
                  <FloatingText text="Taking over the world, one click at a time." />
                  <div className="row">
                    <div className="col-md-6 offset-md-2">
                      <div className="tab-content-area">
                        <h2 className="tab-area-head">
                          Products that
                          <span className="pink"> empower business </span>
                          are the future of product development.
                          <span className="pink"> Solve problems </span>
                          that address the ecosystem as a whole
                          <span className="pink">.</span>
                        </h2>
                        <p>
                          Put your company at the forefront of technology.
                          Utilize the latest technologies backed by top-tier
                          expertise to transform your business’s seemingly
                          complex problems with surprising simple solutions.
                          Expertise in scaling and digital transformation allows
                          you to maintain your business’s competitive edge.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <span />
                    </div>
                  </div>
                  <div className="tab-box-area-main">
                    <div className="row">
                      <div className="col-lg-3 offset-lg-2 col-md-4">
                        <Link
                          to="/solutions/kubernetes/"
                          className="tab-box-area"
                        >
                          <div className="tab-box-icon">
                            <FreshFlows />
                          </div>
                          <div className="tab-box-desc">
                            <h3>Kubernetes</h3>
                          </div>
                          <div className="tab-hidden-desc">
                            <h4>Kubernetes - Cloud Scaling</h4>
                            <p>
                              Discover the benefits of faster application
                              development, delivery, and scale with Kubernetes.
                            </p>
                            <i className="far fa-long-arrow-right" />
                          </div>
                        </Link>
                      </div>
                      <div className="col-lg-3 col-md-4">
                        <Link to="/solutions/" className="tab-box-area">
                          <div className="tab-box-icon">
                            <ConversationsSkills />
                          </div>
                          <div className="tab-box-desc">
                            <h3>Conversations &amp; Skills</h3>
                          </div>
                          <div className="tab-hidden-desc">
                            <h4>Make your products more human</h4>
                            <p>
                              Connect all of your products with Voice via Google
                              Assistant Skill, Amazon Alexa Skill
                            </p>
                            <i className="far fa-long-arrow-right" />
                          </div>
                        </Link>
                      </div>
                      <div className="col-lg-3 col-md-4">
                        <Link
                          to="/solutions/blockchain-development/"
                          className="tab-box-area"
                        >
                          <div className="tab-box-icon">
                            <InsightsAnalytics />
                          </div>
                          <div className="tab-box-desc">
                            <h3>Blockchain</h3>
                          </div>
                          <div className="tab-hidden-desc">
                            <h4>Blockchain - Evolve Your Platform</h4>
                            <p>
                              Blockchain is a distributed database that provides
                              a secure, yet transparent way to make, record and
                              verify any type of transaction
                            </p>
                            <i className="far fa-long-arrow-right" />
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="white-bg-section">
            <div className="container">
              <div className="we-empower-main">
                <div className="row align-items-end">
                  <div className="col-md-5 offset-md-1">
                    <div className="we-empower-area">
                      <h2 className="big-heading">
                        We empower
                        <span className="pink">.</span>
                      </h2>
                      <Image
                        src="home/we-empower.jpg"
                        alt="empower"
                        style={{ maxWidth: 400 }}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="we-empower-desc">
                      <h4>
                        At ATC we keep an eye on the future, innovate
                        continuously and&nbsp;
                        <span className="pink">
                          integrate disruptive technologies
                        </span>
                        &nbsp;into breakthrough solutions.
                      </h4>
                      <p>
                        How do you ensure results? Hire a team that loves what
                        they do. We don’t only deliver success. We ensure its
                        sustainable. This is how we partner with companies to
                        move them forward and help them win.
                      </p>
                      <Link to="/about-us/" className="read-more-btn">
                        LEARN MORE ABOUT US
                        <i className="far fa-long-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
                <FloatingText
                  text="Passionate people helping clients win"
                  dark
                  invert
                />
              </div>
            </div>
          </section>

          <section className="white-bg-section">
            <div className="solutions-main">
              <div className="container">
                <div className="solutions-block">
                  <div className="row">
                    <div className="col-md-11">
                      <h2 className="big-heading">
                        <Link to="/solutions/" style={{ color: 'initial' }}>
                          Our Solutions
                          <span className="pink">.</span>
                        </Link>
                      </h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-5">
                      <div className="solution-rel">
                        <Image
                          type="background"
                          tag="div"
                          src="home/solution-bg.jpg"
                          className="solution-tab-bg-img"
                          style={{ position: 'absolute' }}
                        />
                        <div className="solution-tab-result-area">
                          <h3>{indexSolutions[currentSolution].title}</h3>
                          <p>{indexSolutions[currentSolution].excerpt}</p>
                          {/* <Link
                            to={indexSolutions[currentSolution].link}
                            className="deep-blue-btn red-bg-btn"
                          >
                            <span>
                              LEARN MORE&nbsp;
                              <i className="far fa-long-arrow-right" />
                            </span>
                          </Link> */}
                          <div className="rotated-solution-txt">
                            <h4>Solutions</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 offset-lg-2 col-md-5 offset-md-2">
                      <ul className="solution-tab-list">
                        {indexSolutions.map((i, index) => (
                          <li
                            key={i.id}
                            className={`solution-tab-open${index > 3 ? ' mobile-hide' : ''
                              }`}
                          >
                            {i.id > 0 && i.id < 5 && (
                              <h4 className="d-block d-md-none">{`0${i.id}`}</h4>
                            )}
                            <Link
                              to={i.link}
                              data-id={i.id - 1}
                              onMouseEnter={solutionChangeHandler}
                              className={
                                currentSolution === i.id - 1 ? 'active' : ''
                              }
                            >
                              {i.title}
                            </Link>
                            {i.id > 0 && i.id < 5 && (
                              <>
                                <p className="d-block d-md-none">{i.excerpt}</p>
                                <a
                                  href={i.link}
                                  className="mob-arrow d-block d-md-none"
                                >
                                  <i className="far fa-long-arrow-right" />
                                </a>
                              </>
                            )}
                          </li>
                        ))}
                      </ul>
                      <Link
                        to="/solutions/"
                        className="d-block d-md-none black-btn-mob"
                      >
                        See Solutions &nbsp;
                        <i className="far fa-long-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <SectionIndustries style={{ padding: '150px 0 0' }} />

          <SectionStats isHome />

          <section>
            <div className="container">
              <FloatingText
                text="Innovative solutions driving breakthrough results."
                horizontal
              />
              <div className="video-area-main">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="video-thumb">
                      <button
                        type="button"
                        className="button-unstyled"
                        onClick={toggleVideoOpen}
                        style={{ width: '100%' }}
                      >
                        <Image
                          src="home/atc-team.jpg"
                          alt="video"
                          style={{ width: '100%' }}
                        />
                        <span className="play-icon">
                          <span className="icon" />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="video-desc-area">
                      <h3>
                        Our&nbsp;
                        <span className="pink">mission </span>
                        is to wake up every day driven to meet the needs of our
                        customers
                        <span className="pink">.</span>
                      </h3>
                      <p>
                        We accomplish our mission by enabling our clients’
                        ability to compete by providing the latest technological
                        solutions to give them an edge against their
                        competitors.
                      </p>
                      <Link to="/about-us/" className="read-more-btn">
                        LEARN MORE ABOUT US
                        <i className="far fa-long-arrow-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <SectionHomeClients />

          <section>
            <div className="container">
              <div className="testimonial-block">
                <div className="row">
                  <div className="col-md-8 offset-md-2">
                    <div className="single-testimonial">
                      <h5>
                        “Amazing experience i love it a lot. Thanks to the team
                        that dreams come true, great!”
                      </h5>
                      <div className="testimonial-info">
                        <ProfileIcon />
                        <p>
                          Lassy Chester
                          <br />
                          <span>Art Director</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <FloatingText text="What our clients says" invert />
              </div>
            </div>
          </section>

          <section style={{ position: 'relative' }}>
            <div className="container">
              <div className="white-paper-area">
                <h3>
                  Stay in the know by subscribing to our technology updates including blog, webinar and case study content
                </h3>
                <p></p>
                <a
                  href="https://blog.american-technology.net"
                  rel="noopener noreferrer"
                  className="deep-blue-btn white"
                >
                  <span>
                    <i className="fa fa-link" />
                    &nbsp;&nbsp;See Resources
                  </span>
                </a>
              </div>
            </div>
          </section>
          <section>
            <div className="lets-talk-main">
              <div className="container">
                <h2 className="big-heading" style={{ color: '#fff' }}>
                  Let&apos;s talk.
                </h2>
                <div className="talk-block">
                  <FloatingText
                    text="Taking over the world, one click at a time."
                    dark
                  />
                  <div className="row">
                    <div className="col-md-11 offset-md-1">
                      <div className="talk-form">
                      <div className="_form_1"></div>
                        {/* <HubspotForm
                          portalId="2117583"
                          formId="8f4dd59d-93f6-4a33-bb2d-f9e57897ddb1"
                          submitButtonClass="deep-blue-btn red-bg-btn white"
                          onFormReady={()=> setUTMToHubspotForm()}
                        /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </IndexContainer>
      </Layout>
    </>
  );
};

IndexPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default IndexPage;
